<template>
  <div class="cloud-wrap">
    <div class="box">
      <div class="text-center">
        <section class="wrapper">
          <img :src="image" :alt="alt"
               class="header-section-image">
          <m-a :href="buttonLink" class="h2 text-dark text-decoration-none d-block">
            <i class="bi bi-person"></i>
          </m-a>
        </section>


        <div class="position-absolute col-lg-12 text-center" @click="scrollDown()">
          <div class="text-center btn scroll-parent">
               <span class="scroll-icon">
                  <span class="scroll-icon__dot"></span>
               </span>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'

export default {
  name: "Cloud",
  props: {
    image: {
      default: 'https://cafen2.ir/img/header-section-image.ed15f31b.png'
    },
    alt: {
      default: 'cafe n2'
    },
    buttonName: {default: 'حساب کاربری'},
    buttonLink: {default: 'https://dash.cafen2.ir/login'},
  },
  components: {mA},
  methods: {
    scrollDown() {
      const pageHeight = window.innerHeight

      window.scrollBy({
        top: pageHeight,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>

.cloud-wrap {
  position: relative;
  width: 100%;
  height: 100vh;
}

.box {
  position: absolute;
  width: 100%;
  height: 100vh;
  background-size: cover;
  z-index: 1;
  overflow: hidden;
}

.box .smoke {
  position: absolute;
  top: -10%;
  left: -10%;
  transform: translate3d(0, 0, 0) rotate(0.01deg);
  width: 120%;
  height: 120%;
  background-size: cover;
  z-index: -10;
  opacity: 0.5;
  animation: smokebg 23s infinite alternate;
}

@keyframes smokebg {
  25% {
    transform: translate3d(10px, 0, 0) rotate(5deg);
  }
  50% {
    transform: translate3d(15px, -25px, 0) rotate(0deg);
  }
  75% {
    transform: translate3d(10px, 30px, 0) rotate(5deg);
  }
  100% {
    transform: translate3d(15px, -15px, 0) rotate(0deg);
  }
}

:root {
  --background-color: transparent;
  --text-color: hsl(0, 0%, 100%);
}

.wrapper {
  display: grid;
  place-content: center;
  background-color: var(--background-color);
  min-height: 100vh;
  font-family: 'Oswald', sans-serif;
  font-size: clamp(1.5rem, 1rem + 18vw, 15rem);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-color);
}

.wrapper > div {
  grid-area: 1/1/-1/-1;
}


/* scroll button */
@-webkit-keyframes scroll_2 {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  75% {
    transform: translateY(0.75em);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 0;
  }
}

@keyframes scroll_2 {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  75% {
    transform: translateY(0.75em);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 0;
  }
}

.scroll-icon__dot {
  display: block;
  position: absolute;
  left: 50%;
  background: #000;
  height: 0.5em;
  width: 0.5em;
  top: 0.6em;
  margin-left: -0.25em;
  border-radius: 50%;
  transform-origin: top center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-animation: scroll_2 2s ease-out infinite;
  animation: scroll_2 2s ease-out infinite;
}

.scroll-icon {
  display: block;
  position: relative;
  height: 3em;
  width: 1.5em;
  border: 0.25em solid #000;
  border-radius: 1em;
}

.scroll-parent {
  margin: -130px 0 0 0
}

.header-section-image {
  width: 350px;
  height: auto;
}

@media (max-width: 500px) {
  .header-section-image {
    width: 300px;
  }
  .scroll-parent{
    margin: -80px 0 0 0
  }
}

.products-link {
  font-size: 30px;
  color: var(--dark);
  width: 170px;
  font-family: nazanin;
  margin: 25px auto;
}


</style>